import styled from 'styled-components';

export const PanelWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const NetworkPanelWrapper = styled.div`
  margin: 7px 7px 0 7px;
`;

export const Panel = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  margin:5px;
  padding: 5px;
  flex:1;
  min-width: 350px; /* Minimum width for each child */
`;

export const WidgetContainer = styled.div<{ $isEmpty: boolean }>`
  height: ${props => props.$isEmpty ? '300px' : 'auto'};
`
export const StyledHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
`;
